// @ts-nocheck
"use client";

import { medimoQC } from "@medimo/core-api/internal/next";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { isAuthProtectedPathname } from "./auth-page";

export const TechTouch = () => {
  const pathname = usePathname();
  const enabled = isAuthProtectedPathname(pathname);

  const { data: user } = medimoQC.useQuery("get", "/v2/users", {}, { enabled });
  const { data: subscription } = medimoQC.useQuery(
    "get",
    "/v2/subscription/active",
    {},
    { enabled },
  );
  const { data: featureFlags } = medimoQC.useQuery(
    "get",
    "/v4/feature-flags",
    {},
    { enabled },
  );
  const { data: facility } = medimoQC.useQuery(
    "get",
    "/v2/facility/users/{sub}",
    {
      params: {
        path: { sub: user?.cognito_sub },
      },
    },
    {
      enabled: enabled && !!user?.cognito_sub,
    },
  );

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!("TechtouchObject" in window)) {
      window.TechtouchObject = {
        startTechtouch: () => {
          try {
            if (window.top !== window.self) return;
          } catch (e) {
            return;
          }
          if (
            "TechtouchObject" in window &&
            document.querySelector("script#techtouch-snippet")
          )
            return;
          if ("TechtouchAddon" in window) return;
          window.TechtouchObject = {
            organizationUuid: "orga-69a8007b-c42a-6fae-2847-5a78729b2470",
          };
          const script = document.createElement("script");
          script.async = true;
          script.src =
            "https://apps.techtouch.jp/script/orga-69a8007b-c42a-6fae-2847-5a78729b2470/main.js?projectUuid=proj-69a8019c-72eb-1d38-3e8b-ea43612395c8";
          script.id = "techtouch-snippet";
          const firstScript = document.getElementsByTagName("script")[0];
          firstScript.parentNode?.insertBefore(script, firstScript);
        },
      };
      window.TechtouchObject.startTechtouch();
    }
    if (!("TechtouchAdmin" in window)) {
      window.TechtouchAdmin = {
        customProperty: {
          _data: {},
          get: function (t) {
            return this._data[t];
          },
          set: function (t, e) {
            this._data[t] = e;
          },
          delete: function (t) {
            delete this._data[t];
          },
          keys: function () {
            return Object.keys(this._data);
          },
        },
      };
    }
    // 企業ID
    window?.TechtouchAdmin.customProperty.set(
      "7b0355dd-e9bd-44df-a835-7d3eb1e3c912",
      facility?.facility_id || "",
    );
    // ユーザーID (sub)
    window?.TechtouchAdmin.customProperty.set(
      "b105f5c8-0800-4f41-833b-3e9b1c75b25b",
      user?.cognito_sub || "",
    );
    // Plan ID
    window?.TechtouchAdmin.customProperty.set(
      "2dc18f7e-839a-481a-a463-c4a822a9ad96",
      subscription?.plan_id.toString() || "",
    );
    // medimo chat FF
    window?.TechtouchAdmin.customProperty.set(
      "36f535d5-4918-41c4-8c56-3ae7d6ebdbaf",
      featureFlags === undefined
        ? ""
        : featureFlags.ai_chat_enabled
          ? "ON"
          : "OFF",
    );
  }, [enabled, user, facility, subscription, featureFlags]);
  return null;
};
